import axios from "axios"
// import { history } from "../.."
import { CustomLogger, getMeetingUrl, getToken } from "./utils.actions"
import {
    ConsoleLogger,
    DefaultDeviceController,
    DefaultMeetingSession,
    LogLevel,
    MeetingSessionConfiguration,
    DefaultModality,
    DefaultBrowserBehavior
} from 'amazon-chime-sdk-js';
import moment from "moment";
import { useParams } from "react-router-dom"
import swal from "sweetalert";
import { isMobileOnly, isTablet, isMobileSafari } from 'react-device-detect';
import { VerifyRoomNumber } from "./auth.actions";
import Swal from "sweetalert2";
import { ToastContainer, toast } from 'react-toastify';
import { VERSION_NO } from "./utils.actions"
export const VideoElementsForMap = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",]

export const STORING_MEETING_SESSION = "STORING_MEETING_SESSION"
export const DELETEING_USER_FROM_HASH_MAP = "DELETEING_USER_FROM_HASH_MAP"
export const GETTING_PEOPLE = "GETTING_PEOPLE"
export const SCREEN_SHARE_ON = "SCREEN_SHARE_ON"
export const STORING_HOST_DATA = "STORING_HOST_DATA"
export const SET_ROM_ON_OFF = "SET_ROM_ON_OFF"
export const SPECIAL_BODY_PARTS_LIST_FOR_MEETING = "SPECIAL_BODY_PARTS_LIST_FOR_MEETING"
export const SET_EXERCISE_VIDEO = "SET_EXERCISE_VIDEO"
export const SAVE_SPECIALITY = "SAVE_SPECIALITY"
export const SAVE_SPECIAL_STUFF = "SAVE_SPECIAL_STUFF"
export const VIDEOS_SEARCH = "VIDEOS_SEARCH"
export const GETTING_ROM_PARTS = "GETTING_ROM_PARTS"
export const SETTING_MEETING_ON = "SETTING_MEETING_ON"
export const VIDEO_TILES_UPDATE = "VIDEO_TILES_UPDATE"
export const SAVING_MEETING_USER_ID = "SAVING_MEETING_USER_ID"
export const MEETING_LEFT = "MEETING_LEFT"
export const LOCAL_MIC_MUTE_INDICATOR = "LOCAL_MIC_MUTE_INDICATOR"
export const SAVE_USERS_NAME = "SAVE_USERS_NAME"
export const ENABLE_SOAP = "ENABLE_SOAP"
export const MY_FAVORITE_VIDEOS = "MY_FAVORITE_VIDEOS"
export const GET_CLINIC_LIBRARY = "GET_CLINIC_LIBRARY"
export const STORING_PATIETNS_ID_TITLE = "STORING_PATIETNS_ID_TITLE"
export const UPDATING_IS_PATIENT_STATUS_FOR_THE_HOST = "UPDATING_IS_PATIENT_STATUS_FOR_THE_HOST"
export const SELECTING_ROM_USER = "SELECTING_ROM_USER"
export const UPDATING_PATIENTS_LIST = "UPDATING_PATIENTS_LIST"
export const SAVE_SCREENSHOT = "SAVE_SCREENSHOT"
export const SCREENSHOT_OPEN = "SCREENSHOT_OPEN"
export const SELECTED_PATIENT_ID = "SELECTED_PATIENT_ID"
export const LOCAL_USER_ID = "LOCAL_USER_ID"
export const PERSON_WHO_IS_SHARING_SCREEN = "PERSON_WHO_IS_SHARING_SCREEN"
export const CREATE_ROM_SESSION = "CREATE_ROM_SESSION"
export const SAVING_ROM_FOR_FUTURE = "SAVING_ROM_FOR_FUTURE"


function MyTimeOut(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const CreatingRoom = (roomNo, Name, Title, myBool, IsUrl, isAudioOn = true, isVideoOn = true,participantId) => async (dispatch, getState) => {
    if (!myBool) {

        // history.push("/meeting")

    }
    try {

        CustomLogger("trying to connect with AWS Chime")
        dispatch({
            type: "JOINED_USER_TYPE",
            payload: Title
        })
        const res = await axios.post(getMeetingUrl() + "/api/v1/meeting/join", {
            ID: roomNo || getState().auth.UserData.meetingInfo?.roomNumb,
            Name: Name || `${ getState().auth.UserData.firstName } ${ getState().auth.UserData.lastName }`,
            AttendeeTitle: Title || "Host",
        })
        CustomLogger("Connection Successfull!")

        dispatch({
            type: LOCAL_USER_ID,
            payload: res.data.AttendeeData?.Attendee?.AttendeeId
        })

        dispatch({
            type: SAVE_USERS_NAME,
            payload: Name || `${ getState().auth.UserData.firstName } ${ getState().auth.UserData.lastName }`
        })
        const NewTitle = Title || "Host"

        let requestBody = {};
        let { MeetingData: { Meeting: { MeetingId } } } = res.data;
        let groupId;

        CustomLogger("Calling Verify meeting room")

        dispatch(VerifyRoomNumber(window.location.pathname.replace("/room/", "").substring(0, 9) || getState().auth.UserData.meetingInfo?.roomNumb)).then((res2) => {
            CustomLogger("Verify meeting Positive response")




            if (!res2.status) return

            const VerifyData = res2.data

            axios.post(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/sendPatientInWaitingRoomOnVC`, {
                "userNDme": Name || `${ getState().auth.UserData.firstName } ${ getState().auth.UserData.lastName }`,
                "userType": "patient",
                "hostId": VerifyData.hostId,
                "groupVideoRoomId": VerifyData?.groupVideoRoomId,
                "token": VerifyData?.uniqueSessionId
            });

            requestBody = {
                "sessionId": MeetingId,
                "username": Name || `${ getState().auth.UserData.firstName } ${ getState().auth.UserData.lastName }`,
                "groupVideoRoomId": VerifyData.groupVideoRoomId,
                "roomNumb": window.location.pathname.replace("/room/", "").substring(0, 9),
                "chatToken": res.data.AttendeeData.Attendee.AttendeeId,
                "participateId": getState().auth?.UserData?.adminDocterId || participantId || 0,
                "userdata": null,
                "datetime": moment().unix(),
                "userType": Title,
                "isUrlMen": IsUrl ? 1 : 0,
                "uniqueSessionId": VerifyData.uniqueSessionId
            }
            CustomLogger("Calling onJoinedRoom")

            axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/onJoinedRoom`, requestBody).then((joinResponse) => {
                CustomLogger(" onJoinedRoom Success")

                CustomLogger("Calling updateMeetingOnlineStatus")

                axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/updateMeetingOnlineStatus`, {
                    "meetingUserId": joinResponse?.data?.meetingUserId,
                    "status": 1
                });

                let { meetingUserId } = joinResponse?.data;


                if (meetingUserId) {

                    dispatch({
                        type: SAVING_MEETING_USER_ID,
                        payload: joinResponse.data,
                    })

                    CustomLogger("Calling saveOwnStreamId")


                    axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/saveOwnStreamId`, {
                        "groupVideoRoomId": VerifyData?.groupVideoRoomId,
                        "meetingUserId": meetingUserId,
                        "streamId": MeetingId
                    })
                }
            }).catch(() => {
                CustomLogger(" onJoinedRoom error")

            })

        })


        const logger = new ConsoleLogger('MyLogger', LogLevel.OFF);
        const deviceController = new DefaultDeviceController(logger);
        // alert("Yes")
        const meetingResponse = res.data.MeetingData
        const attendeeResponse = res.data.AttendeeData
        const configuration = new MeetingSessionConfiguration(meetingResponse, attendeeResponse);


        const meetingSession = new DefaultMeetingSession(
            configuration,
            logger,
            deviceController,

        );
        CustomLogger("Connecting with meeting session")
        // navigator.mediaDevices.enumerateDevices()
        CustomLogger("Detecting Audio video devices")

        const audioInputDevices = await meetingSession.audioVideo.listAudioInputDevices();
        CustomLogger("Audio input devices detected")
        const audioOutputDevices = await meetingSession.audioVideo.listAudioOutputDevices();
        CustomLogger("Audio output devices detected")

        const videoInputDevices = await meetingSession.audioVideo.listVideoInputDevices();
        CustomLogger("Video input devices detected")

        // alert("Yes")
        const audioInputDeviceInfo = audioInputDevices && audioInputDevices[0]
        const audioOutputDeviceInfo = audioOutputDevices && audioOutputDevices[0]
        const videoInputDeviceInfo = videoInputDevices && videoInputDevices[0]

        if (audioInputDeviceInfo) {
            CustomLogger("Establishing Connection with Audio Input device ")

            await meetingSession.audioVideo.startAudioInput(audioInputDeviceInfo?.deviceId);

        }

        // console.log(new DefaultBrowserBehavior().supportsSetSinkId())
        // console.log(DefaultBrowserBehavior?.supportsSetSinkId())
        if (audioOutputDeviceInfo && new DefaultBrowserBehavior().supportsSetSinkId()) {
            CustomLogger("Establishing Connection with Audio Output device ")

            await meetingSession.audioVideo.chooseAudioOutput(audioOutputDeviceInfo?.deviceId);

        }
        if (videoInputDeviceInfo) {
            CustomLogger("Establishing Connection with Video Input device ")

            await meetingSession.audioVideo.startVideoInput(videoInputDeviceInfo?.deviceId);

        }

        CustomLogger("Connection established with all devices")

        dispatch({
            type: STORING_MEETING_SESSION,
            payload: meetingSession,
        })

        await MyTimeOut(1000)

        const audioElement = document.getElementById('CHIME_AUDIO_TAG')

        let screenShareVideoElement = document.getElementById('Screen_share')

        meetingSession.audioVideo.bindAudioElement(audioElement);

        CustomLogger("User audio Connected")

        const videoElements = []

        const divElements = []
        for (let index = 1; index <= VideoElementsForMap.length; index++) {

            videoElements.push(document.getElementById(`CHIME_VIDEO_TAG${ index }`))

            divElements.push(document.getElementById(`CHIME_DIV_TAG${ index }`))

        }
        const RoomMap = {}
        const acquireVideoElement = tileId => {
            for (let i = 0; i < VideoElementsForMap.length; i += 1) {
                if (RoomMap[i] === tileId) {
                    // console.log(RoomMap,"RoomMap")
                    return i
                }
            }

            for (let i = 0; i < VideoElementsForMap.length; i += 1) {
                if (!RoomMap.hasOwnProperty(i)) {
                    RoomMap[i] = tileId;
                    // console.log(RoomMap,"RoomMap 2")

                    return i
                }
            }
            throw new Error('no video element is available');
        }

        const releaseVideoElement = tileId => {
            for (let i = 0; i < VideoElementsForMap.length; i += 1) {
                if (RoomMap[i] === tileId) {
                    delete RoomMap[i];
                    divElements[i].className = "video"
                    return;
                }
            }
        };
        let TileAndId = {};
        const roster = {};
        const IsShareScreen = false
        // console.log("Changes implemented")


        const observer = {
            connectionDidBecomePoor: () => {
                alert('Your connection is poor');
            },
            audioInputsChanged: async freshAudioInputDeviceList => {
                // An array of MediaDeviceInfo objects
                // freshAudioInputDeviceList.forEach(mediaDeviceInfo => {
                //     console.log(`Device ID: ${mediaDeviceInfo.deviceId} Microphone: ${mediaDeviceInfo.label}`);
                // });

                const audioInputDevicesUpdated = await meetingSession.audioVideo.listAudioInputDevices();
                CustomLogger("Audio input devices detected")
                // console.log(getState().meeting.localMuteOrNot)
                if (!getState().meeting.localMuteOrNot) return
                const audioInputDeviceInfoUpdated = audioInputDevicesUpdated && audioInputDevicesUpdated[0]

                if (audioInputDeviceInfoUpdated) {
                    meetingSession.audioVideo.realtimeMuteLocalAudio();
                    await meetingSession.audioVideo.chooseAudioInputDevice(audioInputDeviceInfoUpdated?.deviceId);
                    meetingSession.audioVideo.realtimeUnmuteLocalAudio();

                }

            },
            audioOutputsChanged: async freshAudioOutputDeviceList => {
                // console.log('Audio outputs updated: ', freshAudioOutputDeviceList);

                const audioOutputDevicesUpdates = await meetingSession.audioVideo.listAudioOutputDevices();

                CustomLogger("Audio output devices detected");

                const audioOutputDeviceInfoUpdated = audioOutputDevicesUpdates && audioOutputDevicesUpdates[0]
                if (audioOutputDeviceInfoUpdated) {
                    await meetingSession.audioVideo.chooseAudioOutputDevice(audioOutputDeviceInfoUpdated?.deviceId);

                }

            },
            videoInputsChanged: freshVideoInputDeviceList => {
                console.log('Video inputs updated: ', freshVideoInputDeviceList);
            },
            audioVideoDidStart: () => {
                CustomLogger('Audio and Video call Started');
            },

            audioVideoDidStop: async sessionStatus => {
                console.log(sessionStatus)
                console.log(sessionStatus.statusCode(), "sessionStatus.statusCode()")
                await meetingSession.audioVideo.stopVideoInput();
                await meetingSession.audioVideo.stopVideoInput();
                // See the "Stopping a session" section for details.
                CustomLogger('Audio and Video stopped Started');
                dispatch({
                    type: "THE_END"
                })
                // dispatch({
                //     type: SETTING_MEETING_ON,
                //     payload: false,
                // })
                dispatch(MeetingSTopperWithEmailEnter())
            },

            audioVideoDidStartConnecting: reconnecting => {

                if (reconnecting) {
                    // e.g. the WiFi connection is dropped.
                    CustomLogger("Low internet connecingtion detected!")
                }
                CustomLogger("Connection in progress!")

            },
            videoTileDidUpdate: async tileState => {
                if (
                    !tileState.boundAttendeeId ||
                    tileState.isContent ||
                    !tileState.tileId
                ) {

                } else {
                    if (tileState.active) {
                        // realTimeVideoAttendees.add(tileState.boundAttendeeId);

                        dispatch({
                            type: VIDEO_TILES_UPDATE,
                            payload: { add: true, ID: tileState.boundAttendeeId }
                        })

                    } else {
                        // removeTileId(tileState.tileId);
                        dispatch({
                            type: VIDEO_TILES_UPDATE,
                            payload: { add: false, ID: tileState.boundAttendeeId }
                        })
                    }
                }

                if (!tileState.boundAttendeeId) {
                    // if (!tileState.boundAttendeeId || tileState.isContent) {
                    return;
                }


                try {

                    if (tileState.isContent) {


                        document.getElementById('Screen_share').className = "ScreenShareVideo ActiveScreenShare"
                        meetingSession.audioVideo.bindVideoElement(tileState.tileId, document.getElementById('Screen_share'));
                        return
                    }

                    TileAndId[tileState.tileId] = tileState.boundAttendeeId;
                    const ToRenderIndex = acquireVideoElement(tileState.boundAttendeeId)


                    divElements[ToRenderIndex].className = "video active"
                    document.getElementById(`HoverThingy${ ToRenderIndex }`).innerText = tileState.boundExternalUserId.split("#")[1]
                    meetingSession.audioVideo.bindVideoElement(tileState.tileId, videoElements[ToRenderIndex]);
                    console.log(tileState.tileId, "THIS IS ALSO IT")
                    // localTileId = tileState.tileId;
                } catch (error) {
                }

            },
            videoTileWasRemoved: tileId => {
                dispatch({
                    type: VIDEO_TILES_UPDATE,
                    payload: { add: false, ID: TileAndId[tileId] }
                })

                setTimeout(() => {

                    if (roster.hasOwnProperty(TileAndId[tileId])) {
                    } else {
                        releaseVideoElement(TileAndId[tileId]);
                    }

                }, 2000);
            },
            contentShareDidStart: () => {
                CustomLogger("Screen Share started")
            },
            contentShareDidStop: async () => {
                CustomLogger("Screen Share Stopped")

                screenShareVideoElement.className = "ScreenShareVideo "
                await meetingSession.audioVideo.stopContentShare();
                meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                    Start: false,
                    PersonWhoIsSharingScreen: "",

                }), 100000)
                dispatch({
                    type: SCREEN_SHARE_ON,
                    payload: false,
                })
            }
        };

        meetingSession.audioVideo.addDeviceChangeObserver(observer);

        meetingSession.audioVideo.addContentShareObserver(observer);

        meetingSession.audioVideo.addObserver(observer);
        meetingSession.audioVideo.start();

        if (!isAudioOn) {
            meetingSession.audioVideo.realtimeMuteLocalAudio()
            dispatch({
                type: LOCAL_MIC_MUTE_INDICATOR,
                payload: false
            })
            // dispatch(MuteUnmute(meetingSession?.audioVideo?.realtimeIsLocalAudioMuted()))
        }

        if (isVideoOn) {
            meetingSession.audioVideo.startLocalVideoTile();
        } else {
            meetingSession.audioVideo.stopVideoInput();
        }


        dispatch({
            type: STORING_MEETING_SESSION,
            payload: meetingSession,
        })
        const DATA_MESSAGE_TOPIC = "CHAT"
        const IS_PATIENT = "IS_PATIENT"
        const EXERCISE = "EXERCISE"
        const SCREEN_SHARE = "SCREEN_SHARE"
        const MUTE_ALL_UNMUTE_ALL = "MUTE_ALL_UNMUTE_ALL"


        meetingSession.audioVideo.realtimeSubscribeToAttendeeIdPresence(
            (presentAttendeeId, present, ID) => {

                if (!present) {
                    CustomLogger(` ${ ID.split("#")[1] } Left`)
                    releaseVideoElement(presentAttendeeId)
                    delete roster[presentAttendeeId];
                    setTimeout(() => {
                        dispatch({
                            type: DELETEING_USER_FROM_HASH_MAP,
                            payload: presentAttendeeId
                        })
                    }, 2000)

                    dispatch({
                        type: GETTING_PEOPLE,
                        payload: roster
                    })
                    // dispatch(MeetingStopped(window.location.pathname.replace("/room/", "").substring(0, 9), ID.split("#")[1]))
                    // dispatch(deleteingPatientID(window.location.pathname.replace("/room/", "").substring(0, 9), presentAttendeeId))
                    if (presentAttendeeId == getState().meeting.PersonWhoIsSharingScreen) {
                        meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                            Start: false,
                            PersonWhoIsSharingScreen: "",

                        }), 100000)
                        dispatch({
                            type: SCREEN_SHARE_ON,
                            payload: false,
                        })
                    }
                    return;
                }
                CustomLogger(`${ ID.split("#")[1] } Joined`)
                if (getState().meeting.ScreenShareOn) {
                    meetingSession?.audioVideo.realtimeSendDataMessage(SCREEN_SHARE, JSON.stringify({
                        Start: true,
                        PersonWhoIsSharingScreen: "",
                    }), 100000)
                }
                dispatch(gettingPatientIDs(window.location.pathname.replace("/room/", "").substring(0, 9)))

                meetingSession.audioVideo.realtimeSubscribeToVolumeIndicator(
                    presentAttendeeId,
                    (attendeeId, volume, muted, signalStrength) => {
                        const baseAttendeeId = new DefaultModality(attendeeId).base();
                        if (baseAttendeeId !== attendeeId) {
                            // Optional: Do not include the content attendee (attendee-id#content) in the roster.
                            // See the "Screen and content share" section for details.
                            return;
                        }

                        if (roster.hasOwnProperty(attendeeId)) {
                            roster[attendeeId].volume = volume; // a fraction between 0 and 1

                            if (muted == null) return

                            // A null value for any field means that it has not changed.
                            roster[attendeeId].muted = muted; // A booolean
                            roster[attendeeId].signalStrength = signalStrength; // 0 (no signal), 0.5 (weak), 1 (strong)


                        } else {
                            document.getElementById("DING_DONG").play()
                            const index = acquireVideoElement(presentAttendeeId);
                            dispatch({
                                type: STORING_PATIETNS_ID_TITLE,
                                tileID: `isPatientID${ index }`,
                                patientID: presentAttendeeId,
                                videoTile: `CHIME_VIDEO_TAG${ index + 1 }`
                            })
                            divElements[index].className = "video active"
                            document.getElementById(`HoverThingy${ index }`).innerText = ID.split("#")[1]
                            roster[attendeeId] = {
                                attendeeId,
                                volume,
                                muted,
                                signalStrength,
                                name: ID.split("#")[1]
                            };

                            dispatch({
                                type: GETTING_PEOPLE,
                                payload: roster
                            })
                        }
                    }
                );
            }
        );


        meetingSession.audioVideo.realtimeSubscribeToReceiveDataMessage(MUTE_ALL_UNMUTE_ALL, async (dataMessage) => {

            if (dataMessage.json().Mute) {
                dispatch(MuteUnmute(false))
                meetingSession.audioVideo.realtimeSetCanUnmuteLocalAudio(false);
                dispatch({
                    type: LOCAL_MIC_MUTE_INDICATOR,
                    payload: false
                })


            } else {
                // dispatch(MuteUnmute(true))
                meetingSession.audioVideo.realtimeSetCanUnmuteLocalAudio(true);
                // dispatch({
                //     type: LOCAL_MIC_MUTE_INDICATOR,
                //     payload: true
                // })
                // const unmuted = meetingSession.audioVideo.realtimeUnmuteLocalAudio();
            }

        })




        meetingSession.audioVideo.realtimeSubscribeToReceiveDataMessage(SCREEN_SHARE, async (dataMessage) => {
            console.log("Screen share signal recieved!")
            if (getState().meeting.ScreenShareOn && dataMessage.json().Start) return
            dispatch({
                type: PERSON_WHO_IS_SHARING_SCREEN,
                payload: dataMessage.json().PersonWhoIsSharingScreen
            })
            if (dataMessage.json().Start) {
                dispatch({
                    type: SCREEN_SHARE_ON,
                    payload: true,
                })
            } else {
                dispatch({
                    type: SCREEN_SHARE_ON,
                    payload: false,
                })

            }
        })

        meetingSession.audioVideo.realtimeSubscribeToReceiveDataMessage(EXERCISE, (dataMessage) => {

            if (dataMessage.json().video) {
                dispatch({
                    type: SET_EXERCISE_VIDEO,
                    payload: {
                        show: dataMessage.json().show,
                        poster: dataMessage.json().poster,
                        video: dataMessage.json().video,
                    }
                })
                return
            }

            if (dataMessage.json().show && getState().meeting.LoaclUserID !== dataMessage.json().PatientLocalID) return
            dispatch({
                type: SET_EXERCISE_VIDEO,
                payload: {
                    show: dataMessage.json().show,
                    poster: dataMessage.json().poster,
                    video: dataMessage.json().video,
                }
            })

        })

        meetingSession.audioVideo.realtimeSubscribeToReceiveDataMessage(DATA_MESSAGE_TOPIC, (dataMessage) => {
            dispatch({
                type: "CHAT",
                payload: dataMessage.json()
            })
            // console.log(dataMessage.json(),"Mieow")
            if (document.querySelector(".chat-continer")?.clientWidth == 0) {
                toast.info(`${ dataMessage.json().name }: ${ dataMessage.json().Text }`, {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }

        });
        dispatch({
            type: STORING_MEETING_SESSION,
            payload: meetingSession,
        })


    } catch (error) {
        console.log("Error from JoinMeeting Function", error)
        console.log("Error from JoinMeeting Function MSG", error.message)
        // console.log(typeof error.message ,"asim")
        if (error.message === "Permission denied by browser") {
            await Swal.fire({ text: "Please give permission to access audio and video, then reload the page!" })
            return

        }
        if (error.message === "Error fetching device.") {
            await Swal.fire({ text: "Please give permission to access audio and video, then reload the page!" })
            return

        }
        // console.log(error.response?.data, "asim2")
        await Swal.fire({ text: "Something went wrong, Please reload the page and join meeting again!" })
        // await Swal.fire({ text: error?.response?.data })
    }
}


export const MeetingSTopperWithEmailEnter = () => async (dispatch, getState) => {

    const query = new URLSearchParams(location.search)

    let NewEmail = ""


    const roomNo = window.location.pathname.replace("/room/", "").substring(0, 9);

    const Name = getState().meeting.LocalUserName;
    console.log("MEETING ENDED FROM MeetingSTopperWithEmailEnter 1")
    if (getState().meeting.IsHost) return dispatch(MeetingStopped(roomNo, Name))


    let check = false;

    const Chat = getState().meeting.Chat;

    console.log("MEETING ENDED FROM MeetingSTopperWithEmailEnter 2")
    if (Chat.length == 0) return dispatch(MeetingStopped(roomNo, Name))
    for (const value of Chat) {
        if (value.file) {
            check = false;

            break
        }
    }
    console.log("MEETING ENDED FROM MeetingSTopperWithEmailEnter 3")

    if (check) return dispatch(MeetingStopped(roomNo, Name))

    if (!query.get("userType") && query.get("userType") != "Patient" && getState().meeting.JoinedUserType == "Patient") {

        const { value: email } = await Swal.fire({
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: "Leave meeting!",
            cancelButtonText: "Cancel",
            title: 'Left meeting',
            text: "Please enter your email to receive any used attachments or captured screens, The links are valid for 6 hours, please download all the files before expiration. ",
            input: 'email',
            inputPlaceholder: 'Enter your email address',
            inputValidator: (value) => {
                if (value) {
                    if (!value.match(/([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)) return "Please Enter Valid Email"
                }
            }
        })

        NewEmail = email;
    }
    console.log("MEETING ENDED FROM MeetingSTopperWithEmailEnter 4")

    dispatch(MeetingStopped(roomNo, Name, NewEmail))
}

export const MuteUnmute = (bool) => async (dispatch, getState) => {
    const meetingSession = getState().meeting.meetingSession
    if (!bool) {
        dispatch({
            type: LOCAL_MIC_MUTE_INDICATOR,
            payload: false
        })
        return meetingSession.audioVideo.realtimeMuteLocalAudio();
    }

    const unmuted = meetingSession.audioVideo.realtimeUnmuteLocalAudio();
    if (unmuted) {
        dispatch({
            type: LOCAL_MIC_MUTE_INDICATOR,
            payload: true
        })
    } else {
        // See the realtimeSetCanUnmuteLocalAudio use case below.
        swal("You cannot unmute yourself right now!", "The host has muted all the participants", "warning")
        // meetingSession.audioVideo.realtimeMuteLocalAudio();
    }

    dispatch({
        type: STORING_MEETING_SESSION,
        payload: meetingSession,
    })


}
export const MeetingStopped = (id, name, email) => async (dispatch, getState) => {
    dispatch({
        type: MEETING_LEFT,
        payload: true
    })
    const {
        groupVideoRoomId,
        presenterName
    } = getState().auth.VerifyData

    const requestBody = {
        "meetingUserId": getState().meeting.meetingUserId,
        "chatToken": getState().meeting.meetingSession?._configuration?.meetingId,
        "roomNumb": id,
        "userdata": null,
        "groupVideoRoomId": "",
        email: email || "",
        "datetime": moment().unix(),
        "username": name,
    }
    if (getState().meeting.IsHost) {
        requestBody.groupVideoRoomId = groupVideoRoomId;
        requestBody.username = presenterName

    }
    if (!getState().meeting.IsHost) {


        requestBody.groupVideoRoomId = groupVideoRoomId;
        requestBody.username = name
    }

    await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/onLeaveRoom`, requestBody)

    return

}

export const LeaveMeeting = (id, ShouldQuitAll,) => async (dispatch, getState) => {
    try {
        const { meetingSession, LocalUserName } = getState().meeting;


        meetingSession.audioVideo.removeLocalVideoTile();

        dispatch({
            type: MEETING_LEFT,
            payload: true
        })
        meetingSession.audioVideo.stop();
        if (!getState().meeting.IsHost) return

        if (!ShouldQuitAll) return
        // const ID = getState().auth.UserData.meetingInfo?.roomNumb
        const res = await axios.post(getMeetingUrl() + "/api/v1/meeting/end", {
            ID: id,
        })


    } catch (error) {
        console.log(error)
    }
}

export const GettingCommonExercises = () => async (dispatch, getState) => {
    try {
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/SpecialityBodyPartListForMeeting?doctorIdParam=${ getState().auth.UserData.adminDocterId }&passcode=${ "health001~ACHJ" }&token=${ getToken(getState) }`)

        dispatch({
            type: SPECIAL_BODY_PARTS_LIST_FOR_MEETING,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}


export const GetttingVideos = (e) => async (dispatch, getState) => {
    try {
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/GetFavouriteVideosForMeeting/${ e }/0?doctorIdParam=${ getState().auth.UserData.adminDocterId }&passcode=${ "health001~ACHJ" }&token=${ getToken(getState) }`)

        return res.data
    } catch (error) {
        console.log(error)
    }
}

export const GettingSpeciality = () => async (dispatch, getState) => {
    try {

        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/GetLibrarySpecialityCategoryItems`);

        dispatch({
            type: SAVE_SPECIALITY,
            payload: res.data
        })

        dispatch(GetSpecialThings(1))
    } catch (error) {
        console.log(error)
    }
}

export const GetSpecialThings = (e) => async (dispatch, getState) => {


    try {
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/advanceFilterItems/${ e }/2O7HzjNRlHOlLrHweVndNYUkne-H2AQtTXwRyu5eQBKjgPBGRHHTJeyenY0avZqF_ChZ3PbKa4wo_ItcmI5sT_woWdz2ymuMKPyLXJiObE_8KFnc9sprjCj8i1yYjmxP_ChZ3PbKa4wo_ItcmI5sT_woWdz2ymuMKPyLXJiObE_8KFnc9sprjCj8i1yYjmxP_ChZ3PbKa4wo_ItcmI5sT_woWdz2ymuMKPyLXJiObE_8KFnc9sprjCj8i1yYjmxP_ChZ3PbKa4wo_ItcmI5sT_woWdz2ymuMKPyLXJiObE_8KFnc9sprjCj8i1yYjmxP_ChZ3PbKa4wo_ItcmI5sT_woWdz2ymuMKPyLXJiObE_8KFnc9sprjCj8i1yYjmxP_ChZ3PbKa4wo_ItcmI5sT47lzMCiY9ziIzYlit8g6A~~?doctorIdParam=${ getState().auth.UserData.adminDocterId }&passcode=health001~ACHJ&token=${ getToken(getState) }`)

        dispatch({
            type: SAVE_SPECIAL_STUFF,
            payload: res.data
        })

    } catch (error) {
        console.log(error)
    }
}


export const GettingVideoListSearch = (e) => async (dispatch, getState) => {

    try {

        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/GetExerciseVideoByLibraryFilterForMeeting?doctorIdParam=${ getState().auth.UserData.adminDocterId }&passcode=health001~ACHJ&token=${ getToken(getState) }`, e)


        dispatch({
            type: VIDEOS_SEARCH,
            payload: res.data
        })

    } catch (error) {
        console.log(error)
    }
}


export const GetttingRomBodyParts = (e) => async (dispatch, getState) => {


    try {
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/getallROMTypeLkp?doctorIdParam=${ getState().auth?.UserData?.adminDocterId }&passcode=health001~ACHJ&token=${ getToken(getState) }`)


        dispatch({
            type: GETTING_ROM_PARTS,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const uploadFileToS3 = (e) => async (dispatch, getState) => {

    try {
        const MyForm = new FormData()

        MyForm.append("myFile", e);
        MyForm.append("adminDocterId", getState()?.auth?.UserData?.adminDocterId || "guest");
        MyForm.append("meetingUserId", getState().meeting.meetingUserId);

        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/UploadFileForVVReq`, MyForm);
        return res.data
    } catch (error) {
        console.log(error)
    }
}


export const GettingFavVideos = () => async (dispatch, getState) => {
    // ?doctorIdParam=${"getState().auth?.UserData?.adminDocterId"}&passcode=health001~ACHJ&token=${"getToken(getState)

    try {
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/AdminDocterTherapyCategoryForMeeting/${ getState().auth?.UserData?.adminDocterId }/?doctorIdParam=${ getState().auth?.UserData?.adminDocterId }&passcode=health001~ACHJ&token=${ getToken(getState) }`)

        dispatch({
            type: MY_FAVORITE_VIDEOS,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const GettingClinicLibary = () => async (dispatch, getState) => {
    // ?doctorIdParam=${"getState().auth?.UserData?.adminDocterId"}&passcode=health001~ACHJ&token=${"getToken(getState)

    try {
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/v8_1/AdminDocterClinicLibrary/${ getState().auth?.UserData?.adminDocterId }?doctorIdParam=${ getState().auth?.UserData?.adminDocterId }&passcode=health001~AABO&token=${ getToken(getState) }&doctorIdParam=${ getState().auth?.UserData?.adminDocterId }&libraryType=1&passcode=health001~AABO&token=${ getToken(getState) }&versionId=1643264959`)

        dispatch({
            type: GET_CLINIC_LIBRARY,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}


export const GettingSearchVideos = (text, cat, vt, dt) => async (dispatch, getState) => {
    if (!text) return
    try {
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/SearchVideoLibraryForMeeting?doctorIdParam=${ getState().auth?.UserData?.adminDocterId }&catId=${ cat }&searchQuery=${ text }&fromDiagnosis=${ dt }&fromVidTitle=${ vt }`);

        dispatch({
            type: VIDEOS_SEARCH,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const SavingScreenShotOFpatient = (e, loadingStopper) => async (dispatch, getState) => {
    //getState().auth.VerifyData.groupVideoRoomId
    //getState().auth.UserData.adminDocterId
    //getState().auth.UserData.firstName
    //.replace(/^data:image\/[a-z]+;base64,/, "");
    try {
        dispatch({
            type: SAVE_SCREENSHOT,
            payload: e
        })
        const MyFormData = new FormData()

        MyFormData.append("adminDocterId", getState().auth.UserData.adminDocterId)
        MyFormData.append("groupVideoRoomId", getState().auth.VerifyData.groupVideoRoomId)
        MyFormData.append("image_base64", e.replace(/^data:image\/[a-z]+;base64,/, ""))
        MyFormData.append("user_name", getState().auth.UserData.firstName)
        swal("Screenshot Saved!", "Your screenshot has been saved!", "success")
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${ VERSION_NO }/SaveScreenShotVVForMeeting`, MyFormData)


        if (loadingStopper) {
            loadingStopper()
        }
        return
    } catch (error) {
        console.log(error)
    }

}

export const RedirectToEngage = (e) => async (dispatch, getState) => {
    window.location.replace(`${ getState().utils.baseURL }/patientpages/#/access-code/${ e }`);

    // const AndroidApp = "https://play.google.com/store/apps/details?id=com.bluejayPT.engage&hl=en"
    // const IOSApp = "https://apps.apple.com/us/app/bluejay-engage-patient/id1161891845"
    // let isMobileDevice = false;
    // if (/iPhone|Android/i.test(navigator.userAgent)) {
    //     isMobileDevice = true;
    // }

    // if (isMobileDevice) {
    //     // if (true) {
    //     let userAgent2 = navigator.userAgent.toLowerCase();
    //     const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent2);

    //     // if (true) {
    //     if (!isTablet) {
    //         const isAndroid = /Android/i.test(navigator.userAgent);

    //         if (!isAndroid) return window.location.href = IOSApp;
    //         // return window.location.href = AndroidApp
    //     }
    // }
    // window.location.replace(`${getState().utils.baseURL}/patientpages/#/access-code/${e}`);
    // if (isMobileOnly) {

    //     if (isMobileSafari) {
    //         return window.location.href = IOSApp;
    //     } else {
    //         return
    //         //window.location.href = AndroidApp
    //     }

    // }

    // window.location.replace(`${getState().utils.baseURL}/patientpages/#/access-code/${e}`);

}

export const gettingPatientIDs = (e) => async (dispatch, getState) => {
    if (!getState().meeting.IsHost) return
    try {

        const res = await axios.get(getMeetingUrl() + "/api/v1/meeting/getPatients?ID=" + e);

        dispatch({
            type: UPDATING_PATIENTS_LIST,
            payload: res.data.Patients
        })

    } catch (error) {
        console.log(error?.response.data.Msg)
        // console.log(error)
    }
}

export const deleteingPatientID = (mID, aID) => async (dispatch, getState) => {
    return
    if (!getState().meeting.IsHost) return
    try {
        const res = await axios.post(getMeetingUrl() + "/api/v1/meeting/deletePatient", {
            MeetingID: mID,
            AttendeeID: aID,
        });
        dispatch({
            type: UPDATING_PATIENTS_LIST,
            payload: res.data.Patients
        })

    } catch (error) {
        console.log(error?.response.data.Msg)
        // console.log(error)
    }
}

export const startRomSessionWithImage = (RomID, base64, degree, isManualRom) => async (dispatch, getState) => {

    try {
        const body = {
            adminDocterId: getState().auth?.UserData?.adminDocterId,
            bookScheduleId: getState().auth.VerifyData?.meetingBookScheduleId,
            image_base64: base64,
            isValid: 0,
            romTypeLkpId: RomID,
            streamId: getState().meeting.meetingSession._configuration.meetingId,

        }
        if (isManualRom) body["angleDegree"] = degree || 0
        const res = await axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/createBookScheduleROMTypeRelForMeeting`, body);

        dispatch({
            type: CREATE_ROM_SESSION,
            payload: res.data[0]
        })
        if (res.data[0]) {
            return res.data[0]
        }

    } catch (error) {
        console.log(error)
    }
}

export const creatingMeasurements = (angle, base64, index) => async (dispatch, getState) => {
    try {
        const body = {
            adminDocterId: getState().auth?.UserData?.adminDocterId,
            bookScheduleId: getState().auth.VerifyData.meetingBookScheduleId,
            bookScheduleROMTypeRelId: getState().meeting.RomSession.bookScheduleROMTypeRelId,
            correct_angleName: angle,
            image_base64: base64,
            photoIdx: index,
            referToPreviousId: getState().meeting.RomSession.bSROMResultId,
            romTypeLkpId: getState().meeting.RomSession.romTypeLkpId,
            sessionId: getState().meeting.meetingSession._configuration.meetingId,
        }

        const res = await axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/createBSROMResultForMeeting`, body);
        if (res.data[0]) {
            return res.data[0]
        }

    } catch (error) {
        console.log(error)
    }
}

export const SaveROM = (oneM, twoM, threeM, patientName) => async (dispatch, getState) => {

    try {
        const body = {
            bSROMResultIdArr: threeM ? [oneM, twoM, threeM] : [oneM, twoM],
            bookScheduleROMTypeRelId: getState().meeting.RomSession.bookScheduleROMTypeRelId,
            streamId: getState().meeting.meetingSession._configuration.meetingId,
            username: patientName
        }

        const res = await axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/saveBookScheduleROMMeasurementForMeeting`, body)

    } catch (error) {
        console.log(error)
    }
}



export const SaveManualROM = (Angle, base64) => async (dispatch, getState) => {

    try {
        const body = {
            streamId: getState().meeting.meetingSession._configuration.meetingId,
            referToPreviousId: getState().meeting.RomSession.bSROMResultId,
            bSROMResultId: 0,
            angleDegree: Angle,
            pointsCoordinator: 0,
            otherRawData: base64,
            image_base64: base64,
            sessionId: getState().meeting.meetingSession._configuration.meetingId,
            isOriginal: 0,
            data: base64,
            bookScheduleROMTypeRelId: getState().meeting.RomSession.bookScheduleROMTypeRelId,
            originalfilename: `fileName.png`
        }

        const res = await axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/callBackAngleFromUbuntuServer`, body)
        return res.data
    } catch (error) {
        console.log(error)
    }
}

// {
//     "sessionId": "c9e96dc9-30c3-4366-bc6c-32956c0845ee",
//     "real_angle": 45,
//     "pre_pointsCoordinator": null,
//     "error_code": 0
//   }



export const SaveNewNotes = (pLevel, fLevel, ONotes) => async (dispatch, getState) => {
    try {


        const res = await axios.post(`${ getState().utils.baseURL }/PT2/httpdocs/${ VERSION_NO }/PostTelehealthNotes?doctorIdParam=${ getState().auth?.UserData?.adminDocterId }&passcode=health001~ACHJ&token=${ getToken(getState) }`, {
            "doctorScheduleId": getState().auth.VerifyData?.doctorScheduleId || "",
            "painLevel": pLevel,
            "functionalLevel": fLevel,
            "otherNotes": ONotes
        })

        dispatch({
            type: "RTM_NOTES",
            payload: {
                PainLevel: pLevel,
                FunctionalLevel: fLevel,
                OtherNotes: ONotes,
            },
        })

        Swal.fire({ text: "Notes saved successfully!" })
    } catch (error) {
        console.log(error)
        Swal.fire({ text: "Something went wrong" })
    }
}
